import type { PolyFeeSchedule } from '@/lib/polymarket/relay';

/** Polymarket rounds charged fees to 0.00001 USDC. Return cents so the value
 * composes with the rest of the dashboard without discarding sub-cent truth. */
export function estimatePolyOrderFeeCents(args: {
  count: number;
  priceCents: number;
  role: 'maker' | 'taker';
  schedule: PolyFeeSchedule | null | undefined;
}): number | null {
  const { count, priceCents, role, schedule } = args;
  if (schedule == null) return null;
  if (!schedule.feesEnabled) return 0;
  if (role === 'maker' && schedule.takerOnly) return 0;
  const p = priceCents / 100;
  const base = p * (1 - p);
  if (!(base > 0) || !(count > 0) || !(schedule.rate > 0)) return 0;
  const usdc = count * schedule.rate * Math.pow(base, schedule.exponent);
  if (!Number.isFinite(usdc) || usdc <= 0) return 0;
  const micro5 = Math.round(usdc * 1e5);
  return micro5 / 1000;
}
